export default function remove_duplicates_from_list(list) {
  return list.filter((id, index) => {
    return list.indexOf(id) === index;
  });
}
